"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeading = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var _Text = require("../Text/Text");
var StyledHeading = /*#__PURE__*/(0, _styledComponents.default)(_Text.Text).withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['fontFamily'])
}).withConfig({
  displayName: "StyledHeading",
  componentId: "c11n-8-107-0__sc-s7fcif-0"
})([""]);
exports.StyledHeading = StyledHeading;